<template>
    <v-toolbar :color="toolbarColor" dense elevation="0">
        <v-icon left>mdi-file-multiple</v-icon>
        <v-toolbar-title>Applicants</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'applicants-toolbar',
    computed: {
        toolbarColor() {
            return '#FFA800';
        }
    }
}
</script>